import React, { useEffect, useState } from "react";
import { fetchPriceChangePredictions } from "../api/fplApi";

const PriceChangePrediction = ({ compact = false }) => {
  const [rise, setRise] = useState([]);
  const [fall, setFall] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPriceChangePredictions().then((data) => {
      if (!data?.length) { setError("No price change data available."); return; }
      setRise(data.filter((p) => p.predicted_change === "Rise").sort((a,b) => b.transfers_in-a.transfers_in).slice(0,5));
      setFall(data.filter((p) => p.predicted_change === "Fall").sort((a,b) => b.transfers_out-a.transfers_out).slice(0,5));
    }).catch(() => setError("Price change data is unavailable right now.")).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="fpl-empty">Loading price changes…</div>;
  if (error) return <div className="fpl-empty">{error}</div>;

  if (compact) {
    const rows = [
      ...rise.slice(0, 2).map((p) => ({ ...p, direction: "rise" })),
      ...fall.slice(0, 1).map((p) => ({ ...p, direction: "fall" })),
    ];
    return (
      <div className="fpl-price-compact">
        <div className="fpl-market-card-head"><span>Price Changes</span><span>PRICE</span></div>
        {rows.length ? rows.map((p, i) => (
          <div className="fpl-price-compact-row" key={p.id || `${p.web_name}-${i}`}>
            <span className={`fpl-price-direction ${p.direction}`}>{p.direction === "rise" ? "↑" : "↓"}</span>
            <div className="min-w-0 flex-1">
              <strong className="truncate block">{p.web_name}</strong>
              <small>{p.team || "FPL"}</small>
            </div>
            <div className="text-right">
              <strong>£{Number(p.current_price || 0).toFixed(1)}</strong>
              <small className={p.direction}>{p.direction === "rise" ? "Riser" : "Faller"}</small>
            </div>
          </div>
        )) : <div className="fpl-empty py-5">No players listed.</div>}
      </div>
    );
  }

  const list = (title, players, type) => (
    <div className={`fpl-price-list ${type}`}>
      <div className="fpl-price-title"><span>{title}</span><span>{type === "rise" ? "↑" : "↓"}</span></div>
      {players.length ? players.map((p, i) => (
        <div className="fpl-price-row" key={p.id || `${p.web_name}-${i}`}>
          <span className="fpl-price-rank">{i + 1}</span>
          <div className="min-w-0 flex-1"><strong className="truncate block">{p.web_name}</strong><small>{p.team}</small></div>
          <div className="text-right"><strong>£{Number(p.current_price || 0).toFixed(1)}</strong><small>{type === "rise" ? "potential rise" : "potential fall"}</small></div>
        </div>
      )) : <div className="fpl-empty py-5">No players listed.</div>}
    </div>
  );

  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">{list("Risers", rise, "rise")}{list("Fallers", fall, "fall")}</div>;
};
export default PriceChangePrediction;
